import type { GlobalEvents, QBusEventEnum } from "@otto-ec/global-resources";

/**
 *
 */
export const globalEvents = window.o_global.events<GlobalEvents>();
